<div
  class="notifications-panel"
  data-testid="notifications-panel"
  [class.panel-open]="isOpen()"
  [class.panel-closed]="!isOpen()"
>
  <div class="flex items-center justify-between min-h-10">
    <h3 class="text-lg">{{ 'shared.notifications' | translate }}</h3>

    <button
      mat-icon-button
      data-testid="notifications-panel-close-button"
      (click)="onClose()"
      aria-label="Close notifications"
    >
      <app-icon src="/icons/close.svg" class="w-4 h-4" />
    </button>
  </div>

  <div class="flex flex-col gap-2 overflow-y-auto">
    @for (newsItem of news(); track newsItem.id) {
      <div
        class="flex items-start gap-2 cursor-pointer p-2 rounded-lg hover:bg-shikenso-gray-200 active:bg-shikenso-gray-300"
        data-testid="notifications-panel-item"
        (click)="onNewsClick(newsItem)"
      >
        <div class="flex items-center justify-center relative">
          <app-icon-badge
            content="/icons/news.svg"
            backgroundColor="var(--shikenso-pink-base)"
            color="var(--shikenso-purple-base)"
            [size]="32"
            [iconSize]="16"
            [fontSize]="14"
            [borderRadius]="100"
          />

          @if (isUnread(newsItem)) {
            <span class="absolute top-2 right-2 w-1 h-1 rounded-full bg-shikenso-error-base"></span>
          }
        </div>

        <div class="flex flex-col gap-1">
          <div
            class="text-sm line-clamp-3 text-ellipsis"
            data-testid="notifications-panel-item-title"
            matTooltip
            matTooltipPosition="above"
            matTooltipClass="justified-tooltip"
            [appTextClampTooltip]="newsItem.title ?? ''"
          >
            {{ newsItem.title }}
          </div>

          @if (newsItem.start) {
            <div class="text-xs text-shikenso-purple-base-60">{{ newsItem.start | timeago: true }}</div>
          }
        </div>
      </div>
    }
  </div>
</div>
